// tslint:disable-next-line:ordered-imports
import { msgTip } from '@/utils/urlUtils'
import axios from 'axios'
import qs from 'qs'
import { logoutAction } from '../service/auth'

interface ConfigInterface {
  headers?: any
  withCredentials?: boolean
  url?: string
  method?: string
  baseURL?: string
  params?: any
  data?: any
  loading?: boolean
  all?: boolean
  qs?: boolean
}
class ConfigModel {
  public headers: {}
  public withCredentials: true
  public url: ''
  public method: ''
  public baseUrl: ''
  public params: {}
  public data: {}
  public loading: false
  public all: true
  public qs: false
  public constructor(options: ConfigInterface) {
    this.withCredentials = true
    this.headers = {}
    this.url = ''
    this.method = ''
    this.baseUrl = ''
    this.params = options.params || {}
    this.data = options.params || {}
    this.loading = false
    this.all = true
    this.qs = false
    Object.assign(this, options)
  }
}
let loadingInstance: any = null
export function httpWithHeaders(params) {
  return axios.create(params)
}
export function httpAgent(params) {
  const jsonConfig = new ConfigModel(params)
  let http: any = null
  let obj = params
  http = axios.create({ ...jsonConfig, ...obj })
  if (obj.loading) {
    http.interceptors.request.use(
      (config) => {
        return Promise.resolve(config)
      },
      (err) => {
        msgTip({
          type: 'error',
          msg: err
        })
        return Promise.reject(err)
      }
    )
  } else {
    // todo
    http.interceptors.request.use(
      (config) => {
        if (config.method === 'post' && config.qs) {
          config.data = qs.stringify(config.data)
        }
        return Promise.resolve(config)
      },
      (err) => {
        msgTip({
          type: 'error',
          msg: err
        })
        return Promise.reject(err)
      }
    )
  }
  if (params.all) {
    http.interceptors.response.use(
      (response) => {
        let error_info = response.data.error
        if (error_info && error_info == '请登录') {
          logoutAction()
        }
        if (response.data.code === 2) {
          logoutAction()
        }
        if (loadingInstance) {
          loadingInstance.close()
        }
        if (response.data.redirect_url) {
          window.location.replace(response.data.redirect_url)
        }
        if (response.data) {
          return Promise.resolve(response.data)
        } else {
          return Promise.reject(response)
        }
      },
      (error) => {
        if (loadingInstance) {
          loadingInstance.close()
        }
        msgTip({
          type: 'error',
          msg: error.response.status
        })
        return Promise.reject(error.response)
      }
    )
  }

  return http(params)
}
